export const EXTRACTION_SECTION_LABEL = {
  EXTRACTED: 'EXTRACTED FIELDS',
  MANUAL_ENTRY: 'FIELDS (MANUAL ENTRY)',
  EDIT: 'EDIT VALUES',
};

export const RERUN_BUTTON_LABEL = {
  RERUN: 'Re-run extraction',
  RETRY: 'Retry',
};

export const EDIT_BUTTON_LABEL = {
  EDIT_ALL: 'Edit all',
  ENTER_VALUES: 'Enter values',
};

export const SORT_LOW_CONFIDENCE_FIRST_LABEL = 'Low confidence first';

export const RERUN_DISABLED_PROCESSING_TOOLTIP = 'Extraction already in progress';

export const EXTRACTION_RESULTS_SHAPE_ERROR_MESSAGE =
  'Could not read the AI field results for this document — unexpected response shape';

export const EXTRACTION_SKELETON_CARD_COUNT = 4;

export const EXTRACTION_STATUS_POLL_INTERVAL_MS = 5000;

export const EXTRACTION_ROW_FRAME_KIND = {
  CARD: 'card',
  BOX: 'box',
};
